import { SvgIcon, SvgIconProps } from "@mui/material";

export const BarChartIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M7 17v-5M11 17V6M15 17v-6.1M19 17V7M3 3v16a2 2 0 0 0 2 2h16"
      />
    </svg>{" "}
  </SvgIcon>
);
